import {
  GET_SERVICE_CENTER_FAILED_CC,
  GET_SERVICE_CENTER_FAILED_CU,
  GET_SERVICE_CENTER_FAILED_LL,
  GET_SERVICE_CENTER_SUCCESS_CC,
  GET_SERVICE_CENTER_SUCCESS_CU,
  GET_SERVICE_CENTER_SUCCESS_LL,
  GET_SUB_RECIPIENT_FAILED_CC,
  GET_SUB_RECIPIENT_FAILED_CU,
  GET_SUB_RECIPIENT_SUCCESS_CC,
  GET_SUB_RECIPIENT_SUCCESS_CU,
  START_LOADING,
  STOP_LOADING,
} from "../actionConstants";
import { AppDispatch } from "../store";
import { postWithOther } from "./axios";

export const getServiceCenterDetailsFromCorC =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_COR_C_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_SERVICE_CENTER_SUCCESS_CC,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_SERVICE_CENTER_FAILED_CC,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };

export const getServiceCenterDetailsFromCorCu =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_CURR_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_SERVICE_CENTER_SUCCESS_CU,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_SERVICE_CENTER_FAILED_CU,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };

export const getSubRecipientDetailsFromCorC =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_COR_C_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_SUB_RECIPIENT_SUCCESS_CC,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_SUB_RECIPIENT_FAILED_CC,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };
export const getSubRecipientDetailsFromCorCu =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_CURR_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_SUB_RECIPIENT_SUCCESS_CU,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_SUB_RECIPIENT_FAILED_CU,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };

export const getServiceCenterDetailsFromCorL =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const url = `${
        process.env.REACT_APP_ENV === "local"
          ? ""
          : process.env.REACT_APP_LETTER_LINK_URL
      }/api/admin/sso`;

      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_LETTER_LINK_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_SERVICE_CENTER_SUCCESS_LL,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_SERVICE_CENTER_FAILED_LL,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };
